import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { defaultOnError } from "util/conditional/onError";
import locationData from "./location_data.json";
const fetchCountryLoc = async () => new Promise((resolve) => {
  resolve(locationData.sort((a, b) => a.name.common.localeCompare(b.name.common)));
});
const fetchCityLoc = async (params) => fetch(`https://geocode.maps.co/search?${params}`, { method: "GET", cache: "no-cache" });
export function useGetCountryLoc() {
  const { data, isFetching, isLoading } = useQuery({
    queryKey: ["get-country-location"],
    queryFn: () => defaultOnError(fetchCountryLoc(), "Error fetching country location"),
    retry: 1
  });
  return {
    countryLocs: isLoading ? [] : data,
    loadingCountryLocs: isFetching
  };
}
export function useGetCityLoc() {
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();
  const getCityLoc = async ({
    cityName,
    stateProvince,
    countryName
  }) => {
    setIsLoading(true);
    return new Promise((resolve) => {
      if (!countryName) {
        setIsLoading(false);
        resolve({ lat: "", lon: "" });
      }
      const city = cityName.replace(/\s+/g, "+");
      const state = stateProvince == null ? void 0 : stateProvince.replace(/\s+/g, "+");
      const country = countryName == null ? void 0 : countryName.replace(/\s+/g, "+");
      const params = [city ? `city=${city}` : "", state ? `state=${state}` : "", `country=${country}`].join("&");
      queryClient.fetchQuery({
        queryKey: ["get-city-location", params],
        queryFn: () => fetchCityLoc(params),
        retry: 3,
        retryDelay: 1e3
      }).then(async (data) => {
        const geoData = await data.json();
        const { lat, lon } = geoData[0];
        resolve({ lat, lon });
      }).catch(() => {
        resolve({ lat: "", lon: "" });
      }).finally(() => {
        setIsLoading(false);
      });
    });
  };
  return {
    getCityLoc,
    loadingCityLocation: isLoading
  };
}
